/* Pieces of Art homepage, ronde 3. Drie bewegingen die iets vertellen:
   de galm-lijn komt tot rust als je scrolt, het kunstwerk aan de muur wisselt, en de pen schrijft de notities van Marco & Anna.
   Verder: de inklapbare ArtSwitch-tool, het filmpje en de verhalen. */
(function(){
  if(window.__ph26) return; window.__ph26=true;
  var d=document, w=window, calm=w.matchMedia&&w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var track=function(n,x){ if(w.dataLayer){ var o={event:'home_'+n}; for(var k in x) o[k]=x[k]; w.dataLayer.push(o); } };
  d.documentElement.classList.add('ph-js');
  var ready=function(fn){ if(d.readyState!=='loading') fn(); else d.addEventListener('DOMContentLoaded',fn); };
  var IO='IntersectionObserver' in w;
  var seen=function(el,fn,opt){ if(!IO){ fn(); return; } var o=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ o.disconnect(); fn(); } }); },opt||{threshold:.35}); o.observe(el); };

  /* ArtSwitch-tool: open bij een klik op een link ernaartoe, vóór het springen */
  var openTool=function(t){
    if(!t || !t.classList.contains('is-closed')) return false;
    t.classList.remove('is-closed');
    if(w.__ascInit) w.__ascInit();
    setTimeout(function(){ w.dispatchEvent(new Event('resize')); },80);
    track('artswitch_tool_open',{});
    return true;
  };
  var toolFromHref=function(href){
    var u; try{ u=new URL(href,location.href); }catch(e){ return null; }
    if(u.pathname!==location.pathname || !u.hash || u.hash.length<2) return null;
    var t=d.getElementById(decodeURIComponent(u.hash.slice(1)));
    return (t && t.hasAttribute('data-ph-tool')) ? t : null;
  };
  d.addEventListener('click',function(e){
    var a=e.target.closest && e.target.closest('a[href*="#"]'); if(!a) return;
    openTool(toolFromHref(a.getAttribute('href')));
  },true);
  d.addEventListener('click',function(e){
    var x=e.target.closest && e.target.closest('[data-tool-close]'); if(!x) return;
    var t=x.closest('[data-ph-tool]'); if(!t) return;
    t.classList.add('is-closed');
    var back=d.getElementById('ph-artswitch');
    if(back){ if(w.phGoTo) w.phGoTo(back,!calm,false); else back.scrollIntoView({behavior:calm?'auto':'smooth'}); }
    track('artswitch_tool_dicht',{});
  });
  if(location.hash.length>1){ var ht=d.getElementById(decodeURIComponent(location.hash.slice(1))); if(ht && ht.hasAttribute('data-ph-tool')) ready(function(){ openTool(ht); }); }

  /* rekenhulp 'Hoeveel heb ik nodig?': de berekening staat in poa-calc.js en wordt hier bijgeladen als de rekenhulp op de pagina staat.
     Pas je poa-calc.js aan, verhoog dan het getal achter c= zodat bezoekers meteen de nieuwe versie krijgen. */
  (function(){
    var cs=d.currentScript, src=cs && cs.src; if(!src || !d.querySelector('[data-ph-calc]')) return;
    var u=src.replace('poa-home-2026.js','poa-calc.js'); u+=(u.indexOf('?')<0?'?':'&')+'c=2';
    var sc=d.createElement('script'); sc.src=u; sc.async=true; d.head.appendChild(sc);
  })();

  /* een geluidsgolf: luid en grillig, of rustig en bijna vlak (tail: alleen het begin hobbelt, daarna strak) */
  var wavePath=function(W,H,amp,ph,tail){
    var mid=H/2, s='M0 '+mid.toFixed(1), x, e, y, L=Math.max(W*.42,Math.min(W*.72,240));
    for(x=4;x<=W;x+=4){
      e=tail ? (x<L ? Math.pow(1-x/L,1.25)*Math.min(1,x/28) : 0) : 1;
      e*= .55+.45*Math.pow(Math.sin(x*.0125+ph*.21),2);
      y=amp*e*(.56*Math.sin(x*.081+ph)+.3*Math.sin(x*.197-ph*1.3)+.22*Math.sin(x*.033+ph*.55));
      if(tail){ var lim=mid-2, q=Math.exp(2*y/lim); y=lim*(q-1)/(q+1); }
      y+=mid;
      s+=' L'+x+' '+y.toFixed(1);
    }
    return s;
  };

  ready(function(){
    /* 1. galm-lijn onder de hero: links hobbelig, rechts strak; scrollen maakt de hobbels kleiner */
    [].forEach.call(d.querySelectorAll('[data-ph-galm]'),function(g){
      var svg=g.querySelector('svg'), p=g.querySelector('path'); if(!svg||!p) return;
      var W=0,H=0,raf=0,vis=true,last=-1;
      var size=function(){ var r=svg.getBoundingClientRect(); W=Math.max(40,Math.round(r.width)); H=Math.max(20,Math.round(r.height)); svg.setAttribute('viewBox','0 0 '+W+' '+H); last=-1; };
      var draw=function(){
        raf=0;
        var r=g.getBoundingClientRect(), vh=w.innerHeight||800;
        var prog=Math.min(1,Math.max(0,(vh-r.top)/(vh*.75)));
        if(calm) prog=1;
        var key=Math.round(prog*400)+'_'+Math.round(w.scrollY/3);
        if(key===last) return; last=key;
        var amp=H*(.85+.35*Math.pow(1-prog,1.1));
        p.setAttribute('d',wavePath(W,H,amp,w.scrollY*.018,true));
        g.classList.toggle('is-calm',prog>.97);
      };
      var ask=function(){ if(vis && !raf) raf=requestAnimationFrame(draw); };
      size(); draw();
      if(IO) new IntersectionObserver(function(es){ es.forEach(function(e){ vis=e.isIntersecting; if(vis) ask(); }); }).observe(g);
      if(!calm) w.addEventListener('scroll',ask,{passive:true});
      w.addEventListener('resize',function(){ size(); ask(); });
    });

    /* 2. ArtSwitch: dezelfde muur, het kunstwerk wisselt vanzelf zolang je kijkt, of bij een tik */
    [].forEach.call(d.querySelectorAll('[data-ph-wall]'),function(wall){
      var imgs=[].slice.call(wall.querySelectorAll('.ph-as3__img')), btn=wall.querySelector('[data-wall-btn]'), nm=wall.querySelector('[data-wall-name]');
      if(imgs.length<2){ if(btn) btn.hidden=true; return; }
      var i=0, vis=false, hold=0;
      var label=function(){ var n=imgs[i].getAttribute('data-name'); if(nm) nm.textContent= n ? n : ''; };
      var warm=function(){ imgs.forEach(function(s){ var im=s.querySelector('img'); if(im) im.loading='eager'; }); };
      wall.classList.add('is-ready'); imgs[0].classList.add('is-on'); label();
      var show=function(n){ imgs[i].classList.remove('is-on'); i=(n+imgs.length)%imgs.length; imgs[i].classList.add('is-on'); label(); };
      if(IO){ new IntersectionObserver(function(es){ es.forEach(function(e){ vis=e.isIntersecting; if(vis){ warm(); if(!hold) hold=Date.now()+2600; } }); },{threshold:.45}).observe(wall); } else { vis=true; warm(); }
      if(!calm) setInterval(function(){ if(vis && !d.hidden && Date.now()>hold) show(i+1); },4200);
      if(btn) btn.addEventListener('click',function(){ show(i+1); hold=Date.now()+9000; track('artswitch_wissel',{}); });
    });

    /* 3. de pen: notities en handtekeningen schrijven zichzelf, regel voor regel */
    var split=function(el){
      var parts=[].slice.call(el.children.length ? el.children : [el]);
      var lines=[];
      parts.forEach(function(part){
        var txt=part.textContent.replace(/\s+/g,' ').trim(); if(!txt) return;
        part.innerHTML=txt.split(' ').map(function(t){ return '<span class="ph-ww">'+t.replace(/&/g,'&amp;').replace(/</g,'&lt;')+'</span>'; }).join(' ');
        var ws=[].slice.call(part.querySelectorAll('.ph-ww')), cur=null, top=null, groups=[];
        ws.forEach(function(s){ var t=s.offsetTop; if(top===null || Math.abs(t-top)>4){ cur=[]; groups.push(cur); top=t; } cur.push(s.textContent); });
        part.innerHTML=groups.map(function(gp){ return '<span class="ph-wl">'+gp.join(' ').replace(/&/g,'&amp;').replace(/</g,'&lt;')+'</span>'; }).join('<br>');
        [].forEach.call(part.querySelectorAll('.ph-wl'),function(l){ lines.push(l); });
      });
      return lines;
    };
    [].forEach.call(d.querySelectorAll('[data-ph-write]'),function(el){
      if(calm){ el.classList.add('is-written'); return; }
      var orig=el.innerHTML;
      var go=function(){
        var lines=split(el), t=0;
        el.classList.add('is-split');
        lines.forEach(function(l){ var n=l.textContent.length, dur=Math.max(.45,Math.min(1.6,n*.045)); l.style.setProperty('--del',t.toFixed(2)+'s'); l.style.setProperty('--dur',dur.toFixed(2)+'s'); t+=dur+.12; });
        requestAnimationFrame(function(){ requestAnimationFrame(function(){ el.classList.add('is-writing'); }); });
        setTimeout(function(){ el.innerHTML=orig; el.classList.remove('is-split','is-writing'); el.classList.add('is-written'); },(t+.4)*1000);
      };
      var start=function(){ if(d.fonts && d.fonts.ready){ d.fonts.ready.then(go); } else go(); };
      seen(el,start,{threshold:.6});
    });

    /* 4. vergelijking: beide golven beginnen luid, die van Pieces of Art komt bijna helemaal tot rust */
    [].forEach.call(d.querySelectorAll('[data-ph-wave]'),function(svg){
      var p=svg.querySelector('path'); if(!p) return;
      var rest=Math.max(.03,Math.min(1,(parseFloat(svg.getAttribute('data-rest'))||50)/100));
      var W=0,H=0;
      var size=function(){ var r=svg.getBoundingClientRect(); W=Math.max(40,Math.round(r.width)); H=Math.max(16,Math.round(r.height)); svg.setAttribute('viewBox','0 0 '+W+' '+H); };
      var at=function(k,ph){ p.setAttribute('d',wavePath(W,H,(H*.46)*(rest+(1-rest)*k),ph,false)); };
      size(); at(calm?0:1,0);
      if(calm) return;
      seen(svg,function(){
        var t0=performance.now(), D=2200;
        var step=function(now){ var q=Math.min(1,(now-t0)/D), e=1-Math.pow(1-q,3); at(1-e,now*.004); if(q<1) requestAnimationFrame(step); };
        requestAnimationFrame(step);
      },{threshold:.6});
      w.addEventListener('resize',function(){ size(); at(0,0); });
    });

    /* filmpje bij ArtSwitch: speelt alleen als hij in beeld is */
    [].forEach.call(d.querySelectorAll('[data-ph-vid]'),function(f){
      var v=f.querySelector('video'), b=f.querySelector('[data-vid-btn]'), held=false;
      if(!v) return;
      v.muted=true; v.setAttribute('playsinline','');
      var load=function(){ if(v.getAttribute('src') || !v.getAttribute('data-src')) return; var sd=v.getAttribute('data-src-sd'); v.src=(w.innerWidth<700 && sd)? sd : v.getAttribute('data-src'); };
      var play=function(){ load(); var pr=v.play(); if(pr && pr.catch) pr.catch(function(){ f.classList.add('is-paused'); }); f.classList.remove('is-paused'); if(b) b.setAttribute('aria-label','Pauzeer de video'); };
      var pause=function(){ v.pause(); f.classList.add('is-paused'); if(b) b.setAttribute('aria-label','Speel de video af'); };
      if(calm){ f.classList.add('is-paused'); v.preload='metadata'; load(); if(b) b.setAttribute('aria-label','Speel de video af'); }
      if(IO){ new IntersectionObserver(function(es){ es.forEach(function(en){ if(en.isIntersecting){ if(!calm && !held) play(); } else if(!v.paused){ v.pause(); } }); },{threshold:.3}).observe(f); }
      else if(!calm) play();
      if(b) b.addEventListener('click',function(){ if(v.paused){ held=false; play(); } else { held=true; pause(); } track('artswitch_video',{actie:v.paused?'pauze':'afspelen'}); });
    });

    /* verhalen: tabbalk kleurt mee met het gekozen verhaal, lange tekst op mobiel inklappen */
    var checkMore=function(){
      [].forEach.call(d.querySelectorAll('[data-ph-more]'),function(m){
        var btn=m.parentNode.querySelector('[data-more-btn]'); if(!btn || m.getAttribute('data-open')) return;
        m.classList.remove('is-clamped'); btn.hidden=true;
        if(w.innerWidth<900 && m.offsetParent && m.scrollHeight>190){ m.classList.add('is-clamped'); btn.hidden=false; }
      });
    };
    d.addEventListener('click',function(e){
      var mb=e.target.closest && e.target.closest('[data-more-btn]');
      if(mb){ var m=mb.parentNode.querySelector('[data-ph-more]'); if(m){ m.setAttribute('data-open','1'); m.classList.remove('is-clamped'); } mb.hidden=true; track('verhaal_lees_verder',{}); return; }
      var tb=e.target.closest && e.target.closest('.ph-chtabs2 [data-ch]');
      if(tb){
        var pn=d.querySelector('[data-ch-panel="'+tb.getAttribute('data-ch')+'"]'), bar=tb.closest('.ph-chtabs2');
        if(pn && bar){ var cs=getComputedStyle(pn); bar.style.setProperty('--ch-bg',cs.getPropertyValue('--ch-bg')); bar.style.setProperty('--ch-fg',cs.getPropertyValue('--ch-fg')); }
        setTimeout(checkMore,30);
      }
    });
    checkMore();
    var rt; w.addEventListener('resize',function(){ clearTimeout(rt); rt=setTimeout(checkMore,150); });
  });
})();